import { $stateParams } from '../../router';
import Auth from '../auth/auth';
import ClientManager from '../ClientManager';

const Logout = () => {
    if ($stateParams.client && $stateParams.app) {
        // If the query paramaters are set in the url then persist them 
        // to local storage before redirecting the user to cognito as we 
        // cant pass the params in the redirect
        ClientManager.client($stateParams.client);
        ClientManager.app($stateParams.app);
    } else {
        // Clear the local storage just in case anything is still persisted
        ClientManager.clear();
    }

    return Auth.destroy().then(response => {
        if (response && response.Redirect && response.Redirect !== '/logout') return window.location.href = response.Redirect;

        // Fallback back to login page when no redirect is returned
        window.location.href = redirectUrl($stateParams.client, $stateParams.app);
    });
}

const redirectUrl = (client = null, app = null) => {
    if (client && app) {
        return `/login/?client=${client}&app=${app}`;
    }
    
    return '/login/';
}

export default Logout;
